// extracted by mini-css-extract-plugin
export default {"dialogContainer":"dialog_dialogContainer__JwD4J","closeBox":"dialog_closeBox__Nze0Q","closeIcon":"dialog_closeIcon__+6bTa"};